import { GlobalSearchResultModel } from "../model/autogen/GlobalSearchResultModel";

export function getCurrentTotal(results: GlobalSearchResultModel) {
    return results.debateNotes && results.debateNotes.length > 0 ? results.debateNotes.length :
        results.faQs && results.faQs.length > 0 ? results.faQs.length :
            results.issueBriefs && results.issueBriefs.length > 0 ? results.issueBriefs.length :
                results.achievements && results.achievements.length > 0 ? results.achievements.length:
                    results.mediaLines && results.mediaLines.length > 0 ? results.mediaLines.length :
                        results.mpProfiles && results.mpProfiles.length > 0 ? results.mpProfiles.length :
                            results.people && results.people.length > 0 ? results.people.length :
                                results.quotes && results.quotes.length > 0 ? results.quotes.length : 
                                    results.opinionEditorials && results.opinionEditorials.length > 0 ? results.opinionEditorials.length :
                                       /* results.tweets && results.tweets.length > 0 ? results.tweets.length :*/ 0;
}

export function appendResults(currentResults: GlobalSearchResultModel | undefined, newResults: GlobalSearchResultModel) {
    if (!currentResults) {
        return newResults;
    } else {
        //TODO: Merge individual result arrays from both currentResults and newResults
        Object.keys(currentResults)
            .forEach(key => {
                if (Array.isArray(currentResults[`${key}`]) && currentResults[`${key}`].length > 0) {
                    currentResults[`${key}`] = currentResults[`${key}`].concat(newResults[`${key}`])                }
            });
        return currentResults
    }
}
export function hasMoreResults(newResults: GlobalSearchResultModel | undefined) {
    if (!newResults) {
        return false;
    } else {
        return getCurrentTotal(newResults) > 0;
    }
}



// WEBPACK FOOTER //
// ./src/utils/search-result.ts